import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { ErrorMessage } from "@/Common/Api/Dto/ErrorMessage";

abstract class AsyncAction {
    private onError: (errors: ErrorMessage[]) => void;

    constructor(onError?: (errors: ErrorMessage[]) => void) {
        this.onError = onError;
    }

    protected async postAsync<T>(operation: number, requestObj: object): Promise<T> {
        return this.handleClientResponse(await Client.postAsync<T>(operation, requestObj));
    }

    private handleClientResponse<T>(clientResponse: ClientResponse<T>): T {
        if (!clientResponse.isSuccess) {
            this.handleError(clientResponse.errors);
            return null;
        }

        return clientResponse.data;
    }

    private handleError(errors: ErrorMessage[]): void {
        if (!errors?.length)
            return;

        this.onError
            ? this.onError(errors)
            : sessionStore.showPopup(errors);
    }
}

export { AsyncAction };
